import React from 'react'

const CardsIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 6.5C1 5.11929 2.11929 4 3.5 4H20.5C21.8807 4 23 5.11929 23 6.5V17.5C23 18.8807 21.8807 20 20.5 20H3.5C2.11929 20 1 18.8807 1 17.5V6.5ZM3.5 5C2.67157 5 2 5.67157 2 6.5V17.5C2 18.3284 2.67157 19 3.5 19H20.5C21.3284 19 22 18.3284 22 17.5V6.5C22 5.67157 21.3284 5 20.5 5H3.5Z'
        fill='#339CFF'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5 9C5 8.44772 5.44771 8 6 8H8C8.55228 8 9 8.44772 9 9V15C9 15.5523 8.55229 16 8 16H6C5.44772 16 5 15.5523 5 15V9ZM8 9H6V15H8V9ZM11 16V8H12V16H11ZM14 16V8H15V16H14ZM17 16V8H18V16H17Z'
        fill='#339CFF'
      />
    </svg>
  )
}

export default CardsIcon
